import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { object, string } from 'yup';

import { AnimacaoAprender } from 'Component/Animacao';
import Form, { Botao, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import Usuario from 'Interface/Usuarios';
import { login as loginAction } from 'Reducer/Autenticacao';
import { useLoginMutation } from 'Service';
import { useAppDispatch } from 'Store';

const regras = object({
    email: string().email('Inválido').required('Obrigatório'),
    senha: string().required('Obrigatório'),
});

const Login = (): React.ReactElement =>
{
    const navegacao = useNavigate();
    const dispatch = useAppDispatch();
    const [ login ] = useLoginMutation();
    const [ fadeOut, setFadeOut ] = useState<boolean>(false);

    useEffect(() => {
        if (fadeOut) {
            setTimeout(() => {
                navegacao('/intro');
            }, 1500);
        }
    }, [ fadeOut, navegacao ]);

    const enviar = async (dados: Usuario): Promise<void> =>
    {
        try {
            const resposta = await login(dados).unwrap();

            dispatch(loginAction(resposta));

            setFadeOut(true);
        } catch (erro) {
            console.log(erro);
        }
    }

    return (
        <div
            className={[
                'mh-100',
                'bg-dark',
                'animate__animated',
                !fadeOut ? 'animate__fadeIn' : 'animate__fadeOut',
            ].class()}
            style={{ background: 'url(/img/fundo-assinar.webp)' }}
        >
            <div className="container mh-100">
                <div className="mh-100 row justify-content-center align-items-center">
                    <div className="col-md-7">
                        <AnimacaoAprender />
                    </div>
                    <div className="col-md-4">
                        <div className="w-100 d-flex justify-content-center align-items-center flex-column">
                            <Imagem src="logo.png" height="80" className="mb-5" />
                            <div className="bg-white p-5 rounded w-100">
                                <h1 className="mb-4">Entrar</h1>
                                <Form onSubmit={ enviar } regras={ regras }>
                                    <Campo name="email" type="email" rotulo="E-mail" prefixar={ <Icone nome="envelope-fill" /> } />
                                    <Campo name="senha" type="password" rotulo="Senha" prefixar={ <Icone nome="lock-fill" /> } />

                                    <Botao>Entrar</Botao>

                                    <p className="mt-3 mb-0">
                                        É novo por aqui? <a href="#" className="fw-bold text-decoration-none">Crie uma conta agora!</a>
                                    </p>
                                    {/* <p className="mb-0">
                                        Precisa de ajuda?
                                    </p> */}
                                </Form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <p className="text-center text-muted mb-0">
                            O <strong className="text-primary">Estude+</strong> é um serviço de assinatura
                            da <strong className="text-secondary">Faculdade Metropolitana</strong> que
                            provê educação para todos por um <strong>preço acessível</strong>.
                        </p>
                        <p className="text-center text-muted">
                            <small>
                                Quer conhecer mais? Crie já sua conta e acesse o Estude+!
                            </small>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login;
